import { useInteractionTracking, InteractionTrackingContext } from "@/hooks/useInteractionTracking";
import { useAuth } from "@/components/auth/AuthProvider";
import { ReactNode, useEffect, useState } from "react";

interface InteractionTrackerProps {
  children: ReactNode;
}

export const InteractionTracker = ({ children }: InteractionTrackerProps) => {
  const [mounted, setMounted] = useState(false);
  
  useEffect(() => {
    setMounted(true);
  }, []);

  // Only render tracking after mount to avoid SSR issues
  if (!mounted) {
    return <>{children}</>;
  }

  return <InteractionTrackerInner>{children}</InteractionTrackerInner>;
};

const InteractionTrackerInner = ({ children }: InteractionTrackerProps) => {
  // Get userId and loading from AuthProvider - single source of truth
  const { userId, loading } = useAuth();
  const { trackClick, trackPageView, trackFeatureUsage, trackNavigation } = useInteractionTracking(userId, loading);

  return (
    <InteractionTrackingContext.Provider value={{ trackClick, trackPageView, trackFeatureUsage, trackNavigation }}>
      {children}
    </InteractionTrackingContext.Provider>
  );
};
